import { generatePath, Redirect, Route, RouteProps } from "react-router";
import { CouponUseWhen } from "../../../user-api/dist/src/entity/coupon.entity";
import { useAppSelector } from "../app/hooks";
import { appPath, paramName } from "./AppRoute";

export const RegisterEmailRoute = (props: RouteProps): JSX.Element => {

  const answer = useAppSelector((state) => {
    return state.inputAnswer.answer;
  })

  const coupon = useAppSelector((state) => {
    return state.inputAnswer.session.cxHttpRes?.data?.cxShopToken?.cxCoupon;
  })

  if (!coupon || answer.status !== 'fulfilled') {
    const inputPath = generatePath(
      appPath.shopqr.inputAnswer,
      {
        [paramName.surveyQestionPageIndexStr]: 0,
      }
    )
    return <Redirect to={inputPath} />
  }


  if (coupon.useWhen !== CouponUseWhen.LATER) {
    // このパスには通常来ない
    return <></>
  }

  return <Route {...props} />
}
